<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    active?: boolean,
    to?: RouteLocationRaw,
  }>()
</script>

<template>
  <router-link
    v-if="to"
    class="p-2 border-b-2"
    :class="{ active, inactive: !active }"
    :to="to">
    <slot></slot>
  </router-link>
  <app-button
    v-else
    :class="{ active, inactive: !active }"
    class="border-b-2 p-2">
    <slot></slot>
  </app-button>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  .active {
    @apply border-gray-700 text-gray-700 font-bold;
  }
  .inactive {
    @apply text-gray-400 hover:border-gray-400 hover:text-gray-600;
  }
</style>
